module.exports = __webpack_public_path__ + "static/microsoft-dynamics-crm-header-6bf30f89c94631c076743f13083a4ae6.png";